export default __webpack_public_path__ + "static/media/Alfred-Decarolis.bcc5ceb1.png";